import PropTypes from 'prop-types';
import React from "react";
import { Modal as BootstrapModal } from 'react-bootstrap';
import ReactDOM from 'react-dom';

export const ModalData = (props) => {
    const { isShowing, hide, title, children, footer, size, className } = props;

    return isShowing ? ReactDOM.createPortal(
        <React.Fragment>
            <BootstrapModal show={true} onHide={hide} bsSize={size} backdrop="static" dialogClassName={className}>
                <BootstrapModal.Header closeButton>
                    <BootstrapModal.Title>{title}</BootstrapModal.Title>
                </BootstrapModal.Header>
                <BootstrapModal.Body>
                    {children}
                </BootstrapModal.Body>
                {
                    footer &&
                    <BootstrapModal.Footer>
                        {footer}
                    </BootstrapModal.Footer>
                }
            </BootstrapModal>
        </React.Fragment>, document.body
    ) : null;
};

ModalData.defaultProps = {
    size: "large",
    className: "modal-data"
}

ModalData.propTypes = {
    title: PropTypes.string,
    isShowing: PropTypes.bool,
    hide: PropTypes.func,
    size: PropTypes.string,
    className: PropTypes.string,
    footer: PropTypes.element
};